import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

export interface PageQueryParams {
  page?: number;
  size?: number;
  sort?: string;
  [key: string]: string | number | undefined;
}

@Injectable({
  providedIn: 'root'
})
export class HttpUtilsService {
  /**
   * Converts PageQueryParams to HttpParams for HTTP requests.
   * Handles reserved keys (page, size, sort) separately and adds custom filter parameters.
   *
   * @param queryParams - Query parameters object
   * @param reservedKeys - Keys that should be handled separately (default: ['page', 'size', 'sort', 'filter'])
   * @returns HttpParams ready for HTTP request
   */
  toHttpParams(queryParams: PageQueryParams, reservedKeys: string[] = ['page', 'size', 'sort', 'filter']): HttpParams {
    let httpParams = new HttpParams();

    // Handle standard pagination parameters
    if (queryParams.page !== undefined) {
      httpParams = httpParams.set('page', queryParams.page.toString());
    }
    if (queryParams.size !== undefined) {
      httpParams = httpParams.set('size', queryParams.size.toString());
    }
    if (queryParams.sort !== undefined) {
      httpParams = httpParams.set('sort', queryParams.sort);
    }

    // Add custom filter parameters (everything not in reserved keys)
    Object.keys(queryParams).forEach(key => {
      if (!reservedKeys.includes(key) && queryParams[key] !== undefined) {
        httpParams = httpParams.set(key, queryParams[key]!.toString());
      }
    });

    return httpParams;
  }
}
